import { effect, Injectable, OnDestroy } from '@angular/core';
import { DokaIdentityLoginService } from '@doka/identity-login';
import { lastValueFrom, Subject, Subscription } from 'rxjs';
import { Role } from '../models/user-role.model';
import { UsersService } from '@dot/yard-api-client';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService implements OnDestroy {
  constructor(
    private dokaLogin: DokaIdentityLoginService,
    private userService: UsersService,
  ) {
    effect(() => {
      if (this.dokaLogin.isLoggedIn$()) {
        this.getRoles();
      }
    });
  }

  public userRoles: Role[] = [];
  public isAdmin: boolean = false;
  public isAuthorized: boolean = false;
  public isLoadingRoles: boolean = false;

  public $userRolesLoaded: Subject<void> = new Subject<void>();

  private loggedInSub: Subscription | null = null;

  public init(): void {}

  public async getRoles(): Promise<void> {
    this.isLoadingRoles = true;
    try {
      let roles = await lastValueFrom(
        this.userService.getRolesByUserIdAsync(this.dokaLogin.currentUser()?.id as string),
      );
      if (roles) {
        this.userRoles = roles;
        this.checkAuthorization();
      }
    } catch (error) {
      console.warn(error);
    } finally {
      this.isLoadingRoles = false;
      this.$userRolesLoaded.next();
      return;
    }
  }

  public isAuthorizedToAccess(): boolean {
    if (this.isAuthorized || this.isAdmin) {
      return true;
    } else {
      return false;
    }
  }

  private checkAuthorization() {
    if (this.userRoles.find((role: Role) => role.roleName === 'App Portal User')) {
      this.isAuthorized = true;
    } else {
      this.isAuthorized = false;
    }

    if (this.userRoles.find((role: Role) => role.roleName === 'Administrator')) {
      this.isAdmin = true;
      this.isAuthorized = true;
    } else {
      this.isAdmin = false;
    }
  }

  ngOnDestroy(): void {
    this.loggedInSub?.unsubscribe();
    this.loggedInSub = null;
  }
}
